import { render } from "./Conversations.vue?vue&type=template&id=191fb705&scoped=true&lang=pug"
import script from "./Conversations.js?vue&type=script&lang=js&external"
export * from "./Conversations.js?vue&type=script&lang=js&external"

import "./Conversations.vue?vue&type=style&index=0&id=191fb705&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191fb705"]])

export default __exports__